import { Controller } from '@hotwired/stimulus'
import { currentTheme, setTheme, subscribeTheme } from '@/lib/theme'

export default class extends Controller<HTMLButtonElement> {
  static override values = { toLight: String, toDark: String }

  declare readonly toLightValue: string
  declare readonly toDarkValue: string

  private unsubscribe: (() => void) | null = null

  override connect() {
    this.label()
    this.unsubscribe = subscribeTheme(() => this.label())
  }

  override disconnect() {
    this.unsubscribe?.()
  }

  toggle() {
    setTheme(currentTheme() === 'dark' ? 'light' : 'dark')
  }

  private label() {
    this.element.setAttribute(
      'aria-label',
      currentTheme() === 'dark' ? this.toLightValue : this.toDarkValue,
    )
  }
}
